import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing('lg')};
  margin-bottom: ${spacing('lg')};
`;

export const $EmptyCartContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing('lg')};
  margin-bottom: ${spacing('lg')};

  & > div {
    width: 50%;
    @media ${media.maxWidth.sm} {
      width: 100%;
    }
  }
`;

export const $InputGroup = styled.div`
  display: flex;
  justify-content: center;
  gap: ${spacing('sm')};
`;

export const $CenteredText = styled.div`
  text-align: center;
  & > * {
    margin-bottom: ${spacing('xxl')};
  }
`;

export const $OrderLines = styled.div`
  max-height: 610px;
  overflow-y: auto;
  overflow-x: hidden;
`;
